












































































import Vue from "vue";
import EventDetails from "./EventDetails.vue";
import CloneEvent from './CloneEvent.vue';
import axios from "axios";
import { getAvailableRooms } from "../../services";

export default Vue.extend({
  name: "app-calendar",
  components: {
    EventDetails,
    CloneEvent
  },
  data: () => ({
    type: "month",
    types: ["month", "week"],
    mode: "stack",
    weekday: [0, 1, 2, 3, 4, 5, 6],
    value: "",
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-orange",
      "teal",
      "cyan",
      "green",
      "orange",
      "lime",
      "grey darken-1",
      "pink",
      "amber",
    ],
    typeToLabel: {
      month: "Monat",
      week: "Woche",
    },
    roomColoMap: {},
    dialogNew: false,
    selectedOpen: false,
    selectedElement: null,
    selectedEvent: {},
  }),
  methods: {
    async getEvents({ start, end }: any) {
      const events: any[] = [];
      const rooms = await getAvailableRooms();
      rooms
        .sort((a, b) => a.id - b.id)
        .forEach((r, index) => (this.roomColoMap[r.id] = index));
      const res = await axios.get(`/screen-events/api/events/`, {
        params: {
          dstart: start.date,
          dend: end.date,
        },
      });

      for (const ev of res.data) {
        events.push({
          name: ev.title,
          start: new Date(`${ev.date}T${ev.tstart || "00:00:00"}`),
          end: new Date(`${ev.date}T${ev.tend}`),
          timed: true,
          color: ev.room?.id
            ? this.colors[this.roomColoMap[ev.room.id]]
            : "grey darken-1",
          obj: ev,
        });
      }
      this.events = events as any;
    },
    getEventColor(event: any) {
      return event.color;
    },
    rnd(a: number, b: number) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    async closeEventDialog(shouldReload: boolean) {
      const calendar: any = this.$refs.calendar;
      if (shouldReload) {
        await this.getEvents({
          start: calendar.lastStart,
          end: calendar.lastEnd,
        });
      }
      this.selectedOpen = false;
      this.selectedEvent = {};
    },
    setToday() {
      this.value = "";
    },
    newEvent() {
      this.selectedEvent = {
        title: "",
        room: undefined,
        logo: undefined,
        date: "",
        tstart: "",
        tend: "",
      };
      this.dialogNew = true;
    },
    async closeNew(shouldReload: boolean) {
      const calendar: any = this.$refs.calendar;
      if (shouldReload) {
        await this.getEvents({
          start: calendar.lastStart,
          end: calendar.lastEnd,
        });
      }
      this.dialogNew = false;
      this.selectedEvent = {};
    },
    showEvent({ nativeEvent, event }: any) {
      const open = () => {
        this.selectedEvent = Object.assign({}, event.obj);
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
  },
});
